// 系统设置
interface DefaultSettings {
  /**
   * 系统title
   */
  title: string;

  /**
   * 是否显示设置
   */
  showSettings: boolean;
  /**
   * 是否显示多标签导航
   */
  tagsView: boolean;
  /**
   *是否固定头部
   */
  fixedHeader: boolean;
  /**
   * 是否显示侧边栏Logo
   */
  sidebarLogo: boolean;
  /**
   * 导航栏布局
   */
  layout: string;
  /**
   * 主题模式
   */
  theme: string;

  /**
   * 布局大小
   */
  size: string;

  /**
   * 语言
   */
  language: string;

  /**
   * 请求的基础路径
   */
  apiBaseUrl: string;

  /**
   * 请求的基础路径
   */
  passwordTips: string;

  /**
   * 公司名称
   */
  company: string;
}

const origin = window.location.origin;

// 通过域名格式来判定环境
export const env = {
  isTest: /-test|(\.test)/.test(origin),
  isDev: /-dev|(\.dev)/.test(origin),
};

// 获取sas的baseUrl
export const getBaseUrl = () => {
  if (env.isTest) {
    // 目前sas只有两个环境
    return "//cloud-saas-test.woordee.com";
  }
  if (env.isDev) {
    return "//cloud-saas-dev.woordee.com";
  }
  return "//cloud-saas.iol8.com";
};

// 获取预览的url
export const getPreviewBaseUrl = () => {
  if (env.isTest) {
    // 目前sas只有两个环境
    return "https://cloud-test.woordee.com";
  }
  if (env.isDev) {
    return "https://cloud-dev.woordee.com";
  }
  return "https://cloud.woordee.com";
};

// 译稿对比导出url
export const downUrl =
  getPreviewBaseUrl() + `/file/batchDownload/down?fileUrl={0}&fileName={1}`;

const defaultSettings: DefaultSettings = {
  title: "译宝国际",
  showSettings: false,
  tagsView: true,
  fixedHeader: false,
  sidebarLogo: true,
  layout: "left",
  /**
   *  主题模式
   *
   * dark:暗黑模式
   * light: 明亮模式
   */
  theme: "dark",
  size: "default", // default |large |small
  language: "zh-cn", // zh-cn| en
  apiBaseUrl: getBaseUrl(),
  passwordTips: "如忘记密码,请联系管理员重置，管理员联系方式：139 333 33333",
  company: "译宝国际",
};

export default defaultSettings;
